import React from 'react';
import { RouteComponentProps } from 'react-router';

import { Accounts as SuperVendorAccounts } from '../../supervendor/accounts/Accounts';

export function Accounts(props: RouteComponentProps<{}>) {
  return <SuperVendorAccounts rootUrl={props.match.path} />;
}
